import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['all', 'item'];

  // action="input->checkboxes#toggleAll"
  toggleAll({ target }) {
    for (const item of this.itemTargets) {
      item.checked = target.checked;
    }
  }

  // action="input->checkboxes#toggleItem"
  toggleItem({ target }) {
    this.allTarget.checked = this.itemTargets.every((item) => item.checked);
  }
}
